export const REGISTER_USER = 'REGISTER_USER'
export const LOGIN_USER = 'LOGIN_USER'
export const TOGGLE_STATE = 'TOGGLE_STATE'
export const ERROR_STATE = 'ERROR_STATE'
export const VERIFY_CODE = 'VERIFY_CODE'
export const FORGET_PASSWORD = 'FORGET_PASSWORD'
export const VERIFY = 'VERIFY'
export const RESET_PASSWORD = 'RESET_PASSWORD'
